import { getTokenFromStorage, setTokenToStorage } from "./authenticator-service";
import { getCognitoLogoutUrl } from "./authenticator-settings-service";
import { ensureConfig } from "./configuration-service";
import { showDialog } from "./dialog-service";
import { bestGuessRegion } from "./localisation-service";
import { generateQueryString } from "./url-utils-service";
/**
 * The request body to be sent to the /revoke endpoint.
 */
interface RevokeTokenRequest extends Record<string, string> {
  token: string;
  client_id: string;
}

export const showLogout = () => {
  console.log("Logging out...");
  return showDialog(`/logout/logout.html?region=${bestGuessRegion().code}`, {
    width: 30,
    height: 40,
    promptBeforeOpen: false,
  });
};

export async function logout(): Promise<void> {
  const regionConfig = ensureConfig();

  const cognitoUrl = regionConfig.CognitoUrl;
  const clientId = regionConfig.CognitoClientId;

  const token = await getTokenFromStorage(cognitoUrl, clientId);

  if (!token?.refreshToken) {
    return;
  }

  const request: RevokeTokenRequest = {
    client_id: clientId,
    token: token.refreshToken,
  };

  const url = `${cognitoUrl}/oauth2/revoke`;

  const headers: Record<string, string> = {
    "Content-Type": "application/x-www-form-urlencoded",
  };

  const body = generateQueryString(request);

  await fetch(url, {
    body: body,
    method: "POST",
    headers: headers,
  });

  setTokenToStorage(undefined);

  const logoutUrl = getCognitoLogoutUrl();
  console.log("redirecting to logout: ", logoutUrl);
  // PDN TODO this has to launch in the dialog location.href = logoutUrl;
}
